package components

import frontend.lib.classList
import org.jetbrains.compose.web.dom.P
import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label

class TCheckboxAttrsBuilder {
    var onChange: (value: Boolean) -> Unit = {}
    var onInputCallback: (value: Boolean) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var description: @Composable() () -> Unit = {}
    var isDisabled = false

    fun onChange(handler: (value: Boolean) -> Unit) { onChange = handler }
    fun onInput(handler: (value: Boolean) -> Unit) { onInputCallback = handler }

    fun label(l: @Composable() () -> Unit) { label = l }
    fun description(d: @Composable() () -> Unit) { description = d }
    fun disabled() { isDisabled = true }
}

@Composable
fun TCheckbox(
    id: String,
    value: Boolean,
    attrs: TCheckboxAttrsBuilder.() -> Unit = {}
) {
    val builder = TCheckboxAttrsBuilder()
    attrs.invoke(builder)

    Div(attrs = { classList("mt-1 space-y-4") }) {
        Div(attrs = { classList("flex items-start") }) {
            Div(attrs = { classList("flex items-center h-5") }) {
                Input(InputType.Checkbox) {
                    id(id)
                    classList("focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded")
                    checked(value)
                    name("text")
                    onChange { builder.onChange(!value) }
                    if (builder.isDisabled) disabled()
                }
            }

            Div(attrs = { classList("ml-3 text-sm") }) {
                Label(forId = id, attrs = {
                    classList("font-medium text-gray-700")
                }) {  builder.label() }
                P(attrs = { classList("text-gray-500") }) { builder.description() }
            }
        }
    }
}
